const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export async function setCooldownSettings(cooldownMinutes) {
    const response = await fetch(`${API_URL}/api/v1/cooldown/settings`, {
        method: 'PUT',
        headers: getAuthHeader(),
        body: JSON.stringify({ cooldownMinutes })
    });
    return response;
}

export async function getCooldownSettings() {
    const response = await fetch(`${API_URL}/api/v1/cooldown/settings`, {
        method: 'GET',
        headers: getAuthHeader()
    });
    return response;
}

export async function getCooldownStatus() {
    const response = await fetch(`${API_URL}/api/v1/cooldown/status`, {
        method: 'GET',
        headers: getAuthHeader()
    });
    return response;
}
